<template>
  <table class="table">
    <tbody>
      <tr>
        <td class="table-label">Energy</td>
        <td colspan="1" v-if="gasData">Gas</td>
        <td v-if="electricityData">Electricity</td>
      </tr>

      <tr>
        <td class="table-label" style="width:40%;">Supplier</td>
        <td colspan="1" v-if="gasData">{{ gasData.supplier }}</td>
        <td v-if="electricityData">{{ electricityData.supplier }}</td>
      </tr>

      <tr>
        <td class="table-label" style="width:40%;">Tariff Name</td>
        <td colspan="1" v-if="gasData">{{ gasData.tariffName }}</td>
        <td v-if="electricityData">{{ electricityData.tariffName }}</td>
      </tr>

      <tr>
        <td class="table-label" style="width:40%;">Tariff Ends On</td>
        <td colspan="1" v-if="gasData">{{ gasData.tariffEndsOn }}</td>
        <td v-if="electricityData">{{ electricityData.tariffEndsOn }}</td>
      </tr>

      <tr>
        <td class="table-label" style="width:40%;">Payment Method</td>
        <td colspan="1" v-if="gasData">{{ gasData.paymentMethod }}</td>
        <td v-if="electricityData">{{ electricityData.paymentMethod }}</td>
      </tr>

      <tr>
        <td class="table-label" style="width:40%;">Standing Charge</td>
        <td colspan="1" v-if="gasData">{{ removeUnits(gasData.standingCharge) }} <small>p/day</small></td>
        <td v-if="electricityData">{{ removeUnits(electricityData.standingCharge) }} <small>p/day</small></td>
      </tr>

      <tr>
        <td class="table-label" style="width:40%;">Unit rate <small>(p/kWh)</small></td>
        <td colspan="1" v-if="gasData">{{ removeUnits(gasData.unitRate) }}</td>
        <td v-if="electricityData">
          <div v-if="removeUnits(electricityData.unitRateNight) == '0'">
            {{ removeUnits(electricityData.unitRateDay) }}
          </div>

          <div class="row" v-if="removeUnits(electricityData.unitRateNight) != '0'">
            <div class="col-xs-6">
              <div>
                {{ removeUnits(electricityData.unitRateDay) }}
              </div>
              <small>Day</small>
            </div>

            <div class="col-xs-6">
              <div>
                {{ removeUnits(electricityData.unitRateNight) }}
              </div>
              <small>Night</small>
            </div>
          </div>
        </td>
      </tr>

      <tr>
        <td class="table-label" style="width:40%;">Price Guaranteed Until</td>
        <td colspan="1" v-if="gasData">{{ gasData.priceGuaranteedUntil }}</td>
        <td v-if="electricityData">{{ electricityData.priceGuaranteedUntil }}</td>
      </tr>

      <tr>
        <td class="table-label" style="width:40%;">Exit Fees</td>
        <td colspan="1" v-if="gasData">{{ gasData.exitFees }}</td>
        <td v-if="electricityData">{{ electricityData.exitFees }}</td>
      </tr>

      <tr>
        <td class="table-label" style="width:40%;">Discount And Additional Charges</td>
        <td colspan="1" v-if="gasData">
          <ul class="bullet-points">
            <li v-for="item in gasData.discountsAndAdditionalCharges" :key="item">{{ item }}</li>
          </ul>
        </td>
        <td v-if="electricityData">
          <ul class="bullet-points">
            <li v-for="item in electricityData.discountsAndAdditionalCharges" :key="item">{{ item }}</li>
          </ul>
        </td>
      </tr>

      <tr>
        <td class="table-label" style="width:40%;">Additional Products Or Services Included</td>
        <td colspan="1" v-if="gasData">
          <ul class="bullet-points">
            <li v-for="item in gasData.additionalProductsAndServices" :key="item">{{ item }}</li>
          </ul>
        </td>
        <td v-if="electricityData">
          <ul class="bullet-points">
            <li v-for="item in electricityData.additionalProductsAndServices" :key="item">{{ item }}</li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'TilTable',
  props: {
    gasData: Object,
    electricityData: Object
  },
  methods: {
    removeUnits (value) {
      if (!value) return '';
      return value.split(' ')[0];
    }
  }
};
</script>

<style lang="scss"></style>
